import { render, staticRenderFns } from "./vsDropdownGroup.vue?vue&type=template&id=af77482a&lang=html"
import script from "./vsDropdownGroup.vue?vue&type=script&lang=js"
export * from "./vsDropdownGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports